import { proxy } from 'valtio'
import { useSnapshot } from 'valtio/react'

const nodeToolbarStore = proxy<Record<string, string | null>>({})

export function useNodeToolbar(nodeId?: string) {
    const snapshot = useSnapshot(nodeToolbarStore)

    if (!nodeId) {
        return null
    }

    return snapshot[nodeId] ?? null
}

export function openNodeToolbar(nodeId: string, toolbarKey: string) {
    nodeToolbarStore[nodeId] = toolbarKey
}

export function closeNodeToolbar(nodeId: string) {
    if (nodeToolbarStore[nodeId] === null) {
        return
    }

    nodeToolbarStore[nodeId] = null
}

export function toggleNodeToolbar(nodeId: string, toolbarKey: string) {
    nodeToolbarStore[nodeId] = nodeToolbarStore[nodeId] === toolbarKey ? null : toolbarKey
}

export function isListNodeToolbar(toolbar: string) {
    return ['galleryEditor', 'textListEditor'].includes(toolbar)
}

export const nodeToolbarMaximizedStore = proxy<Record<string, boolean>>({})

export function useNodeToolbarMaximized(nodeId?: string) {
    const snapshot = useSnapshot(nodeToolbarMaximizedStore)
    if (!nodeId) return false
    return snapshot[nodeId] ?? false
}

export function setNodeToolbarMaximized(nodeId: string, isMaximized: boolean) {
    nodeToolbarMaximizedStore[nodeId] = isMaximized
}